import { EntityDetails } from '@rematter/ui-web';
import { useAtom, useAtomValue } from 'jotai';

import * as state from '../../_state/loadDetails.state';
import { customerPortalRoutes } from '../../routes';

import {
  LoadBookingBadge,
  LoadPurchaseOrderBadge,
  LoadStatusBadge,
} from './LoadBadges';
import { LoadHeaderActions } from './LoadHeaderActions';
import { LoadTabAttachments } from './LoadTabAttachments';
import { LoadTabInfo } from './LoadTabInfo';
import { LoadTabMaterials } from './LoadTabMaterials';
import { LoadTabPhotos } from './LoadTabPhotos';

import { useModuleLocation } from '~/shared/hooks/useModuleLocation';

export const LoadDetailsView = () => {
  const [, navigate] = useModuleLocation();
  const [tab, setTab] = useAtom(state.$tab);

  const { data: load, isLoading } = useAtomValue(state.$loadDetails);

  const handleBackPressed = () => navigate(customerPortalRoutes.loads);

  return (
    <EntityDetails
      className="@LoadDetailsView"
      onChangeTab={(tab) => setTab(tab, { replace: true })}
      currentTab={tab}
      onBackPressed={handleBackPressed}
      primaryTitle={
        isLoading
          ? 'Loading...'
          : (load?.supplier?.name ?? 'Unassigned Supplier')
      }
      secondaryTitle={
        load?.loadNumber
          ? `Load #${String(load.loadNumber).padStart(6, '0')}`
          : undefined
      }
      badges={
        <>
          {load?.purchaseOrderNumber && (
            <LoadPurchaseOrderBadge
              purchaseOrderNumber={load?.purchaseOrderNumber}
            />
          )}
          {load?.booking?.documentNumber && (
            <LoadBookingBadge bookingNumber={load?.booking?.documentNumber} />
          )}
          {load?.status && (
            <LoadStatusBadge status={load?.status} reviewed={load?.reviewed} />
          )}
        </>
      }
      headerActions={<LoadHeaderActions />}
      tabs={{
        loadInfo: {
          title: 'Load Info',
          content: LoadTabInfo,
        },
        materials: {
          title: 'Materials',
          content: LoadTabMaterials,
        },
        photos: {
          title: 'Photos',
          content: LoadTabPhotos,
        },
        attachments: {
          title: 'Attachments',
          content: LoadTabAttachments,
        },
      }}
    />
  );
};
